export default {"src":"/_next/static/media/dark-facebook-icon.98c04232.svg","height":28,"width":28};